import Counter from '../Counter';

const Demo6Statistic1 = () => {
    return (
        <div id="statistic-1" className="bg-01 pt-70 pb-70 statistic-section division">
            <div className="container white-color">
                <div className="statistic-1-wrapper">
                    <div className="row justify-content-md-center row-cols-1 row-cols-md-3">
                        <div id="sb-1-1" className="col">
                            <div className="statistic-block wow fadeInUp">
                                <h2 className="h2-xl statistic-number">
                                    <Counter end={28} />%
                                </h2>
                                <h5 className="h5-lg">Faster Access</h5>
                                <p className="p-lg">Enim nullam tempor at sapien gravida donec a blandit integer posuere porta justo velna</p>
                            </div>
                        </div>
                        <div id="sb-1-2" className="col">
                            <div className="statistic-block wow fadeInUp">
                                <h2 className="h2-xl statistic-number">
                                    <Counter end={54} />%
                                </h2>
                                <h5 className="h5-lg">Productivity</h5>
                                <p className="p-lg">Enim nullam tempor at sapien gravida donec a blandit integer posuere porta justo velna</p>
                            </div>
                        </div>
                        <div id="sb-1-3" className="col">
                            <div className="statistic-block wow fadeInUp">
                                <h2 className="h2-xl statistic-number">
                                    <Counter end={36} />%
                                </h2>
                                <h5 className="h5-lg">Secure Access</h5>
                                <p className="p-lg">Enim nullam tempor at sapien gravida donec a blandit integer posuere porta justo velna</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Demo6Statistic1;
